<div class="error-bank-dialog__container">
  <h2>
    {{ (data.multipoint ? 'EXISTENT_BANK_ACCOUNT_MULTIPOINT' : 'EXISTENT_BANK_ACCOUNT') | i18nextEager }}
  </h2>
  <p
    class="error-bank-dialog__text"
    [ngClass]="{
      'error-bank-dialog__text--bottom-0': data.multipoint
    }"
  >
    {{
      (data.multipoint ? 'EXISTENT_BANK_ACCOUNT_DESCRIPTION_MULTIPOINT' : 'EXISTENT_BANK_ACCOUNT_DESCRIPTION')
        | i18nextEager
    }}
  </p>
  <div *ngIf="data.multipoint" class="error-bank-dialog__list">
    <div *ngFor="let account of data.accounts" class="error-bank-dialog__item">
      <span class="error-bank-dialog__circle"></span>
      <p>{{ 'BANK_ACCOUNT' | i18nextEager }}: {{ account }}</p>
    </div>
  </div>
  <div class="error-bank-dialog__buttons">
    <button class="secondary" (click)="closeDialog(false)">{{ 'EXISTENT_BANK_ACCOUNT_GO_BACK' | i18nextEager }}</button>
    <button (click)="closeDialog(true)">{{ 'EXISTENT_BANK_ACCOUNT_CONTINUE' | i18nextEager }}</button>
  </div>
</div>
